import * as React from 'react';
import styles from './index.less';
import { connect } from 'dva';
import { ConnectState, NodeManagerModelState } from '@/models/connect';
import { Helmet } from 'react-helmet';
import { Dispatch } from 'redux';
import FComponentsLib from '@freelog/components-lib';
import { Radio, Space } from 'antd';
import { FI18n, FServiceAPI, FUtil } from '@freelog/tools-lib';
import * as AHooks from 'ahooks';
import {
  OnChange_Setting_Cover_Action,
  OnChange_Setting_CoverImage_Action,
  OnChange_Setting_ExhibitMatchTags_Action,
  OnChange_Setting_Limitation_Action,
  OnClick_Setting_SaveIntroduction_Action,
  OnChange_Setting_NodeLimitationMessage_Action,
  OnChange_Setting_Title_Action,
  OnClick_Setting_CancelEdit_Action,
  OnClick_Setting_SaveEdit_Action,
  OnClick_Setting_StartEdit_Action,
  OnMount_SettingPage_Action,
  OnUnmount_SettingPage_Action,
  SettingEditModule,
} from '@/models/nodeManagerPage';
import fMessage from '@/components/fMessage';
import FUploadNodeCover from '@/components/FUploadNodeCover';
import defaultNodeCover from '@/assets/default-node-cover.png';
import FNodeCoverImage from '@/components/FNodeCoverImage';
// import FInput_MultiLine from '@/components/FInput_MultiLine';
import { history } from '@@/core/history';
import { FetchNodesAction } from '@/models/nodes';
import FModal from '@/components/FModal';
// import FSingleLineInput from '@/components/FSingleLineInput';
import FIcons from '@/components/FIcons';
import FCopyToClipboard from '@/components/FCopyToClipboard';
import FInput_PinyinSafeTextCounter from '@/components/FInput_PinyinSafeTextCounter';
import FCoverImageEditor from '@/components/FCoverImageEditor';
import { JPEG_PNG_ACCEPT_IMAGE_TYPES } from '@/components/FUploadCover';
import ResourceLabelsCard from '@/components/FResourceLabelsCard';
import fEditLabelsDrawer from '@/components/fEditLabelsDrawer';
import FIntroductionInput from '@/components/FIntroductionInput';
// import FLoadingTip from '@/components/FLoadingTip';

const NODE_COVER_IMAGE_DESC = FI18n.i18nNext.t('nodemgnt_nodesetting_nodecover_info');

interface SettingProps {
  dispatch: Dispatch;
  nodeManagerPage: NodeManagerModelState;
}

function Setting({ dispatch, nodeManagerPage }: SettingProps) {
  const [$deleteNodeModalOpen, set$deleteNodeModalOpen, get$deleteNodeModalOpen] =
    FUtil.Hook.useGetState<boolean>(false);
  const [$deleteNodeName, set$deleteNodeName, get$deleteNodeName] =
    FUtil.Hook.useGetState<string>('');

  AHooks.useMount(() => {
    dispatch<OnMount_SettingPage_Action>({
      type: 'nodeManagerPage/onMount_SettingPage',
    });
  });

  AHooks.useUnmount(() => {
    dispatch<OnUnmount_SettingPage_Action>({
      type: 'nodeManagerPage/onUnmount_SettingPage',
    });
  });

  const editingModules = nodeManagerPage.setting_editingModules;
  const isEditingModule = (module: SettingEditModule) => editingModules.includes(module);
  const exhibitTags = nodeManagerPage.setting_nodeInfo.exhibitMatchTags;

  const openDeleteNodeModal = React.useCallback(async () => {
    const {
      ret,
      errCode,
      msg,
      data,
    }: {
      ret: number;
      errCode: number;
      msg: string;
      data?: { totalBalance: number };
    } = await FServiceAPI.Payment.queryFinancialAccountInfo({
      accountType: 2,
      ownerId: nodeManagerPage.nodeId,
    });
    if (ret !== 0 || errCode !== 0) {
      fMessage(msg, 'error');
      return;
    }
    if (data && data.totalBalance > 0) {
      fMessage(
        FI18n.i18nNext.tAuto('nodemgnt_nodesetting_deletenode_error_payoutsbalanceno0'),
        'error',
      );
      return;
    }
    set$deleteNodeModalOpen(true);
  }, [nodeManagerPage.nodeId, set$deleteNodeModalOpen]);

  const renderModuleActions = (module: SettingEditModule, saveDisabled = false) => {
    if (isEditingModule(module)) {
      return (
        <Space size={10} style={{ flexShrink: 0 }}>
          <FComponentsLib.FTextBtn
            type={'default'}
            style={{ fontSize: 12 }}
            onClick={() => {
              dispatch<OnClick_Setting_CancelEdit_Action>({
                type: 'nodeManagerPage/onClick_Setting_CancelEdit',
                payload: { module },
              });
            }}
          >
            {FI18n.i18nNext.tAuto('btn_cancel')}
          </FComponentsLib.FTextBtn>
          <FComponentsLib.FTextBtn
            style={{ fontSize: 12 }}
            disabled={saveDisabled}
            onClick={() => {
              dispatch<OnClick_Setting_SaveEdit_Action>({
                type: 'nodeManagerPage/onClick_Setting_SaveEdit',
                payload: { module },
              });
            }}
          >
            {FI18n.i18nNext.tAuto('btn_save')}
          </FComponentsLib.FTextBtn>
        </Space>
      );
    }
    return (
      <FComponentsLib.FTextBtn
        type={'primary'}
        style={{ fontSize: 12, flexShrink: 0 }}
        onClick={() => {
          dispatch<OnClick_Setting_StartEdit_Action>({
            type: 'nodeManagerPage/onClick_Setting_StartEdit',
            payload: { module },
          });
        }}
      >
        {FI18n.i18nNext.tAuto('nodemgnt_nodesetting_btn_edit')}
      </FComponentsLib.FTextBtn>
    );
  };

  return (
    <>
      <Helmet>
        <title>{`节点设置 · ${nodeManagerPage.nodeTitle || nodeManagerPage.nodeName} - Freelog`}</title>
      </Helmet>

      {/*<FSiderContentLayout*/}
      {/* <FLeftSiderLayout
        sider={<Sider />}
        type='empty'
      > */}
        <div className={styles.content}>
          <div className={styles.inner}>
            <div className={styles.header}>
              <FComponentsLib.FTitleText
                type={'h1'}
                text={FI18n.i18nNext.t('nodemgnt_nodesetting_page_title')}
              />
              <div className={styles.headerMeta}>
                <div className={styles.headerMetaItem}>
                  <FComponentsLib.FContentText
                    text={FI18n.i18nNext.t('nodemgnt_nodesetting_nodeaddress')}
                    type={'additional2'}
                  />
                  <FComponentsLib.FContentText
                    text={nodeManagerPage.setting_nodeUrl}
                    type={'additional2'}
                  />
                  <FCopyToClipboard
                    text={nodeManagerPage.setting_nodeUrl}
                    iconStyle={{ fontSize: 14 }}
                    title={FI18n.i18nNext.t('tip_copy_node_domain')}
                  />
                </div>
                <div className={styles.headerMetaItem}>
                  <FComponentsLib.FContentText
                    text={FI18n.i18nNext.t('nodemgnt_nodesetting_nodeid')}
                    type={'additional2'}
                  />
                  <FComponentsLib.FContentText
                    text={String(nodeManagerPage.setting_nodeName)}
                    type={'additional2'}
                  />
                  <FCopyToClipboard
                    text={String(nodeManagerPage.setting_nodeName)}
                    iconStyle={{ fontSize: 14 }}
                    title={'复制'}
                  />
                </div>
              </div>
            </div>
            <div className={styles.settingCard}>
              <div className={styles.cardHeader}>
                <div className={styles.cardTitleBlock}>
                  <FComponentsLib.FContentText
                    type={'highlight'}
                    text={FI18n.i18nNext.t('nodemgnt_nodesetting_nodelogo')}
                  />
                </div>
              </div>
              <div className={styles.cardBody}>
                {nodeManagerPage.setting_pageState === 'loading' ? (
                  <div style={{ height: 80 }} />
                ) : (
                  <FUploadNodeCover
                    acceptImageTypes={JPEG_PNG_ACCEPT_IMAGE_TYPES}
                    onUploadSuccess={(url) => {
                      dispatch<OnChange_Setting_Cover_Action>({
                        type: 'nodeManagerPage/onChange_Setting_Cover',
                        payload: { value: url },
                      });
                    }}
                    onError={(err) => {
                      fMessage(err, 'error');
                    }}
                  >
                    <div className={styles.nodeCover}>
                      <FNodeCoverImage
                        src={nodeManagerPage.setting_nodeInfo.cover || defaultNodeCover}
                      />
                      <div className={styles.nodeCoverMask}>
                        <span>
                          {
                            // 编辑
                            FI18n.i18nNext.tAuto('common_btn_edit')
                          }
                        </span>
                      </div>
                    </div>
                  </FUploadNodeCover>
                )}
              </div>
            </div>

            <div className={styles.settingCard}>
              <div className={styles.cardHeader}>
                <div className={styles.cardTitleBlock}>
                  <FComponentsLib.FContentText
                    type={'highlight'}
                    text={FI18n.i18nNext.t('nodemgnt_nodesetting_nodetitle')}
                  />
                </div>
                {renderModuleActions(
                  'title',
                  nodeManagerPage.setting_nodeTitle === '' ||
                    nodeManagerPage.setting_nodeTitle_Error !== '',
                )}
              </div>
              <div className={styles.cardBody}>
            {!isEditingModule('title') ? (
              <div className={styles.nodeName}>
                {nodeManagerPage.setting_nodeInfo.title ? (
                  <FComponentsLib.FContentText
                    text={nodeManagerPage.setting_nodeInfo.title}
                    type={'normal'}
                  />
                ) : (
                  <i style={{ color: '#999' }}>暂无无内容...</i>
                )}
              </div>
            ) : (
              <div className={styles.nodeName1}>
                {/* <FComponentsLib.FInput.FSingleLine */}
                <FInput_PinyinSafeTextCounter
                  value={nodeManagerPage.setting_nodeTitle}
                  onChangeValue={(v) => {
                    dispatch<OnChange_Setting_Title_Action>({
                      type: 'nodeManagerPage/onChange_Setting_Title',
                      payload: {
                        value: v,
                      },
                    });
                  }}
                  lengthLimit={100}
                  size='middle'
                  style={{ width: 380 }}
                  // placeholder={FI18n.i18nNext.tAuto('form_input_singlelinetxt_error_length')}
                />
                {nodeManagerPage.setting_nodeTitle_Error !== '' && (
                  <>
                    <div style={{ height: 5 }} />
                    <FComponentsLib.FContentText
                      type={'additional2'}
                      text={nodeManagerPage.setting_nodeTitle_Error}
                      style={{ color: '#EE4040' }}
                    />
                  </>
                )}
              </div>
            )}
              </div>
            </div>

            <div className={styles.introductionWrap}>
              <FIntroductionInput
                className={styles.introductionBlock}
                lengthLimit={1000}
                value={nodeManagerPage.setting_nodeInfo.introduction}
                title={FI18n.i18nNext.t('nodemgnt_nodesetting_nodeshortdesc')}
                tip={FI18n.i18nNext.t('listing_description_info')}
                btnText={FI18n.i18nNext.t('listing_description_btn')}
                onOK={async (value: string) => {
                  await dispatch<OnClick_Setting_SaveIntroduction_Action>({
                    type: 'nodeManagerPage/onClick_Setting_SaveIntroduction',
                    payload: { value },
                  });
                }}
              />
            </div>

            <div className={styles.settingCard}>
              <div className={styles.cardBody}>
                <FComponentsLib.FContentText
                  text={FI18n.i18nNext.tAuto('nodemgnt_nodesetting_nodecover')}
                  type={'highlight'}
                />
                <div style={{ height: 5 }} />
                <FComponentsLib.FContentText text={NODE_COVER_IMAGE_DESC} type={'additional2'} />
                <div style={{ height: 20 }} />
                <FCoverImageEditor
                  lodding={false}
                  src={nodeManagerPage.setting_nodeInfo.coverImage || ''}
                  use={'resource'}
                  acceptImageTypes={JPEG_PNG_ACCEPT_IMAGE_TYPES}
                  uploadDescription={NODE_COVER_IMAGE_DESC}
                  width={200}
                  onChange={(url) => {
                    dispatch<OnChange_Setting_CoverImage_Action>({
                      type: 'nodeManagerPage/onChange_Setting_CoverImage',
                      payload: { value: url },
                    });
                  }}
                />
              </div>
            </div>

            <div className={styles.settingCard}>
              <div className={styles.cardTitleBlock}>
                <FComponentsLib.FContentText
                  text={FI18n.i18nNext.tAuto('nodemgnt_nodesetting_filter')}
                  type={'highlight'}
                />
                {exhibitTags.length > 0 && (
                  <FComponentsLib.FContentText
                    text={FI18n.i18nNext.tAuto('nodemgnt_nodesetting_filter_info_tag')}
                    type={'additional2'}
                  />
                )}
              </div>

              {exhibitTags.length === 0 ? (
                <div className={styles.labelsEmptyWrap}>
                  <div className={styles.labelsEmptyTip}>
                    <FComponentsLib.FContentText
                      text={
                        // 为节点添加展品标签筛选功能，帮助访客快速筛选并精准找到感兴趣的展品。
                        FI18n.i18nNext.t('nodemgnt_nodesetting_filter_info_tag')
                      }
                      type={'additional2'}
                      style={{ textAlign: 'center', width: '100%' }}
                    />
                  </div>
                  <FComponentsLib.FRectBtn
                    type='transparent'
                    className={styles.outlineBtn}
                    onClick={async () => {
                      const result: null | string[] = await fEditLabelsDrawer({
                        labels: [],
                      });
                      if (result === null) {
                        return;
                      }
                      dispatch<OnChange_Setting_ExhibitMatchTags_Action>({
                        type: 'nodeManagerPage/onChange_Setting_ExhibitMatchTags',
                        payload: { value: result },
                      });
                    }}
                  >
                    {
                      // 添加标签
                      FI18n.i18nNext.tAuto('rqr_input_resouce_tag_empty_btn')
                    }
                  </FComponentsLib.FRectBtn>
                </div>
              ) : (
                <ResourceLabelsCard
                  labels={exhibitTags}
                  style={{ background: '#F7F7F7', border: 'none', padding: '0 10px', minHeight: 44 }}
                  onClick={async () => {
                    const result: null | string[] = await fEditLabelsDrawer({
                      labels: exhibitTags,
                    });
                    if (result === null) {
                      return;
                    }
                    dispatch<OnChange_Setting_ExhibitMatchTags_Action>({
                      type: 'nodeManagerPage/onChange_Setting_ExhibitMatchTags',
                      payload: { value: result },
                    });
                  }}
                />
              )}
            </div>

            <div className={styles.settingCard}>
              <div className={styles.cardHeader}>
                <div className={styles.cardTitleBlock}>
                  <FComponentsLib.FContentText
                    type={'highlight'}
                    text={FI18n.i18nNext.t('nodemgnt_nodesetting_visibility')}
                  />
                </div>
                {renderModuleActions(
                  'visibility',
                  nodeManagerPage.setting_nodeLimitation === 'pause' &&
                    nodeManagerPage.setting_nodeLimitationMessage.length > 100,
                )}
              </div>
              <div className={styles.cardBody}>
            <div className={styles.permission}>
              <div className={styles.permissionRow}>
                <div className={styles.permissionOption}>
                  {!isEditingModule('visibility') ? (
                    <Radio
                      checked={nodeManagerPage.setting_nodeInfo.limitation === 'public'}
                      disabled={true}
                      style={{ margin: 0 }}
                    />
                  ) : (
                    <Radio
                      checked={nodeManagerPage.setting_nodeLimitation === 'public'}
                      onChange={(e) => {
                        if (e.target.checked) {
                          dispatch<OnChange_Setting_Limitation_Action>({
                            type: 'nodeManagerPage/onChange_Setting_Limitation',
                            payload: {
                              value: 'public',
                            },
                          });
                        }
                      }}
                      disabled={false}
                      style={{ margin: 0 }}
                    />
                  )}
                  <FComponentsLib.FContentText
                    text={FI18n.i18nNext.t('nodemgnt_nodesetting_visibility_public')}
                    type={'normal'}
                  />
                </div>
                <div className={styles.permissionDetail}>
                  <FComponentsLib.FContentText
                    text={FI18n.i18nNext.t('nodemgnt_nodesetting_visibility_public_info')}
                    type={'additional2'}
                    style={{ lineHeight: '20px' }}
                  />
                </div>
              </div>

              <div className={styles.permissionRow}>
                <div className={styles.permissionOption}>
                  {!isEditingModule('visibility') ? (
                    <Radio
                      checked={nodeManagerPage.setting_nodeInfo.limitation === 'private'}
                      disabled={true}
                      style={{ margin: 0 }}
                    />
                  ) : (
                    <Radio
                      checked={nodeManagerPage.setting_nodeLimitation === 'private'}
                      onChange={(e) => {
                        if (e.target.checked) {
                          dispatch<OnChange_Setting_Limitation_Action>({
                            type: 'nodeManagerPage/onChange_Setting_Limitation',
                            payload: {
                              value: 'private',
                            },
                          });
                        }
                      }}
                      disabled={false}
                      style={{ margin: 0 }}
                    />
                  )}
                  <FComponentsLib.FContentText
                    text={FI18n.i18nNext.t('nodemgnt_nodesetting_visibility_private')}
                    type={'normal'}
                  />
                </div>
                <div className={styles.permissionDetail}>
                  <FComponentsLib.FContentText
                    text={FI18n.i18nNext.t('nodemgnt_nodesetting_visibility_private_info')}
                    type={'additional2'}
                    style={{ lineHeight: '20px' }}
                  />
                </div>
              </div>

              <div className={styles.permissionRow}>
                <div className={styles.permissionOption}>
                  {!isEditingModule('visibility') ? (
                    <Radio
                      checked={nodeManagerPage.setting_nodeInfo.limitation === 'pause'}
                      disabled={true}
                      style={{ margin: 0 }}
                    />
                  ) : (
                    <Radio
                      checked={nodeManagerPage.setting_nodeLimitation === 'pause'}
                      onChange={(e) => {
                        if (e.target.checked) {
                          dispatch<OnChange_Setting_Limitation_Action>({
                            type: 'nodeManagerPage/onChange_Setting_Limitation',
                            payload: {
                              value: 'pause',
                            },
                          });
                        }
                      }}
                      disabled={false}
                      style={{ margin: 0 }}
                    />
                  )}
                  <FComponentsLib.FContentText
                    text={FI18n.i18nNext.t('nodemgnt_nodesetting_visibility_hidefromvisitor')}
                    type={'normal'}
                  />
                </div>
                <div className={styles.permissionDetail}>
                <FComponentsLib.FContentText
                  text={FI18n.i18nNext.t('nodemgnt_nodesetting_visibility_hidefromvisitor_info')}
                  type={'additional2'}
                  style={{ lineHeight: '20px' }}
                />
                {isEditingModule('visibility') &&
                  nodeManagerPage.setting_nodeLimitation === 'pause' && (
                    <>
                      <div className={styles.changeNoticeHeader}>
                        <FComponentsLib.FContentText
                          text={FI18n.i18nNext.t('nodemgnt_nodesetting_changenotice_title')}
                          type={'additional2'}
                        />
                        <FComponentsLib.FTextBtn
                          type={'primary'}
                          style={{ fontSize: 12 }}
                          onClick={() => {
                            self.open(
                              '/nodePausePreview?tip=' +
                                encodeURIComponent(
                                  nodeManagerPage.setting_nodeLimitationMessage ||
                                    FI18n.i18nNext.t('nodemgnt_nodesetting_changenotice_default'),
                                ),
                            );
                          }}
                        >
                          {/* 预览 */}
                          {FI18n.i18nNext.tAuto('nodemgnt_nodesetting_changenotice_btn_preview')}
                        </FComponentsLib.FTextBtn>
                      </div>
                      {/* <FComponentsLib.FInput.FSingleLine */}
                      <FInput_PinyinSafeTextCounter
                        value={nodeManagerPage.setting_nodeLimitationMessage}
                        onChangeValue={(v) => {
                          dispatch<OnChange_Setting_NodeLimitationMessage_Action>({
                            type: 'nodeManagerPage/onChange_Setting_NodeLimitationMessage',
                            payload: {
                              value: v,
                            },
                          });
                        }}
                        lengthLimit={100}
                        style={{ width: '100%', maxWidth: 740 }}
                        placeholder={FI18n.i18nNext.t('nodemgnt_nodesetting_changenotice_default')}
                      />
                    </>
                  )}
                </div>
              </div>
            </div>
              </div>
            </div>

          {nodeManagerPage.setting_nodeInfo.limitation === 'pause' && (
            <div className={styles.deleteNodeRow}>
              <FComponentsLib.FTextBtn
                type={'danger'}
                style={{ display: 'flex', alignItems: 'center', gap: 2 }}
                onClick={() => {
                  void openDeleteNodeModal();
                }}
              >
                <FIcons.FDelete style={{ color: 'inherit', fontSize: 14 }} />
                {/*<span>删除节点</span>*/}
                <span>{FI18n.i18nNext.tAuto('nodemgnt_nodesetting_btn_deletenode')}</span>
              </FComponentsLib.FTextBtn>
            </div>
          )}

          <div style={{ height: 100, flexShrink: 0 }} />
          </div>
        </div>
      {/* </FLeftSiderLayout> */}

      <FModal
        title={null}
        footer={null}
        open={$deleteNodeModalOpen}
        width={640}
        centered={true}
        onCancel={() => {
          set$deleteNodeModalOpen(false);
          set$deleteNodeName('');
        }}
      >
        <div
          style={{
            width: '100%',
            minHeight: 380,
            backgroundColor: 'white',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
            padding: '30px 40px',
            boxSizing: 'border-box',
          }}
        >
          <div style={{ height: 30 }} />
          <FComponentsLib.FTitleText
            type={'popup'}
            text={FI18n.i18nNext.t('nodemgnt_nodesetting_deletenode_title')}
          />
          <div style={{ height: 70 }} />
          <div style={{ width: '100%', maxWidth: 520 }}>
            <FComponentsLib.FTipText
              type={'second'}
              style={{ textAlign: 'center', width: '100%' }}
              text={FI18n.i18nNext.t('nodemgnt_nodesetting_deletenode_msg', {
                NodeTitle: nodeManagerPage.setting_nodeTitle,
                NodeID: nodeManagerPage.setting_nodeName,
              })}
            />
          </div>
          <div style={{ height: 20 }} />
          {/*删除节点{NodeTitle}(节点标识：{NodeID})将会删除当前节点上所有展品和授权记录*/}
          <FComponentsLib.FContentText
            type={'additional2'}
            style={{ color: '#666', width: '100%', maxWidth: 520, textAlign: 'center' }}
            text={FI18n.i18nNext.t('nodemgnt_nodesetting_deletenode_msg2')}
          />
          <div style={{ height: 20 }} />
          {/* <FSingleLineInput */}
          <FInput_PinyinSafeTextCounter
            style={{ width: '100%', maxWidth: 520 }}
            lengthLimit={-1}
            value={$deleteNodeName}
            placeholder={FI18n.i18nNext.t('nodemgnt_nodesetting_deletenode_label', {
              NodeID: nodeManagerPage.setting_nodeName,
            })}
            onChangeValue={(value) => {
              // console.log('*********************');
              set$deleteNodeName(value);
            }}
          />
          <div style={{ height: 40 }} />
          <div style={{ display: 'flex', gap: 30 }}>
            <FComponentsLib.FTextBtn
              type={'default'}
              onClick={() => {
                set$deleteNodeModalOpen(false);
                set$deleteNodeName('');
              }}
            >
              {FI18n.i18nNext.tAuto('btn_cancel')}
            </FComponentsLib.FTextBtn>
            <FComponentsLib.FRectBtn
              disabled={$deleteNodeName !== nodeManagerPage.setting_nodeName}
              type={'danger1'}
              onClick={async () => {
                const { ret, errCode, msg, data } = await FServiceAPI.Node.deleteNode({
                  nodeId: nodeManagerPage.nodeId,
                });
                if (ret !== 0 || errCode !== 0) {
                  return fMessage(msg, 'error');
                }

                if (!data) {
                  return fMessage('节点删除失败', 'error');
                }
                await fMessage(
                  FI18n.i18nNext.tAuto('nodemgnt_nodesetting_deletenode_msg_done', {
                    NodeTitle: nodeManagerPage.setting_nodeTitle,
                    NodeID: nodeManagerPage.setting_nodeName,
                  }),
                  'success',
                );
                // console.log(data);
                await dispatch<FetchNodesAction>({
                  type: 'nodes/fetchNodes',
                });
                history.replace(FUtil.LinkTo.dashboard());
                // set$deleteNodeModalOpen(false);
              }}
            >
              {FI18n.i18nNext.tAuto('nodemgnt_nodesetting_deletenode_btn')}
            </FComponentsLib.FRectBtn>
          </div>
          <div style={{ height: 30 }} />
        </div>
      </FModal>
    </>
  );
}

export default connect(({ nodeManagerPage }: ConnectState) => ({
  nodeManagerPage,
}))(Setting);
